// Central, controlled vocabulary of topic tags for Thematic Studies.
//
// Topics reference tags by `id` only (see TopicMetadata.tags in data.ts). Keeping
// the vocabulary here — rather than letting topics carry free-form strings —
// prevents near-duplicate tags (e.g. "Holy Name" vs "Harinama" vs "Nama") and
// keeps the set searchable/browsable. `data.test.ts` validates that every tag id
// used in data.ts exists here, and that every tag here is used by at least one topic.

export interface TagDefinition {
    id: string;
    label: string;
}

export const TAGS: TagDefinition[] = [
    { id: 'holy-name', label: 'Holy Name (Harināma)' },
    { id: 'no-karma-for-devotees', label: 'No Karma for Devotees' },
    { id: 'bhakti-is-causeless', label: 'Bhakti is Causeless (Ahaitukī)' },
    { id: 'bhakti-is-unstoppable', label: 'Bhakti is Unstoppable (Apratihatā)' },
    { id: 'surrender', label: 'Surrender (Śaraṇāgati)' },
    { id: 'bhakti-surpasses-karma-jnana-yoga', label: 'Bhakti Surpasses Karma, Jñāna and Yoga' },
    { id: 'varnasrama-dharma-limits', label: 'Varṇāśrama-Dharma and Its Limits' },
    { id: 'distress-as-mercy', label: "Distress as the Lord's Mercy" },
    { id: 'krishna-as-supreme-truth', label: 'Kṛṣṇa as the Supreme Absolute Truth' },
    { id: 'rasa-tattva', label: 'Rasa-Tattva (Kṛṣṇa as the Source of Rasa)' },
    { id: 'glories-of-bhagavatam', label: 'Glories of Śrīmad-Bhāgavatam' },
    { id: 'prema', label: 'Prema (Divine Love)' },
    { id: 'pure-unmixed-bhakti', label: 'Pure, Unmixed Bhakti (Kevala-Bhakti)' },
    { id: 'vyasadeva-and-bhagavatam', label: 'Vyāsadeva and the Writing of Śrīmad-Bhāgavatam' },
    { id: 'vaisnava-aparadha-atonement', label: 'Vaiṣṇava Aparādha & Atonement' },
    { id: 'stages-of-bhakti', label: 'Stages of Bhakti Development (Śraddhā to Prema)' },
    { id: 'astrology-and-destiny', label: 'Astrology, Karma & Destiny' },
    { id: 'maya-and-yoga-maya', label: 'Māyā and Yoga-māyā' },
    { id: 'modes-of-nature', label: 'Modes of Nature (Sattva, Rajas, Tamas)' },
    { id: 'material-nature', label: 'Material Nature (Prakṛti)' },
    { id: 'creation', label: 'Creation & the Elements' },
];

const TAGS_BY_ID: Record<string, TagDefinition> = Object.fromEntries(TAGS.map((tag) => [tag.id, tag]));

export const TAG_IDS: string[] = TAGS.map((tag) => tag.id);

export function getTagById(tagId: string): TagDefinition | undefined {
    return TAGS_BY_ID[tagId];
}

export function getTagLabel(tagId: string): string {
    return TAGS_BY_ID[tagId]?.label ?? tagId;
}
